import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";

import HomePage from "./pages/HomePage";
import DoctorsPage from "./pages/DoctorsPage";
import ServicesPage from "./pages/ServicesPage";
import AppointmentPage from "./pages/AppointmentPage";
import ContactPage from "./pages/ContactPage";
import GalerieFoto from "./pages/GalerieFoto";

import ChatBox from "./components/ChatBot";

// IMPORT IMAGINI BACKGROUND
import desktopbgImage from "./assets/images/desktopbg.png";
import mobilebgImage from "./assets/images/mobilebg.jpg";

function App() {
  return (
    <Router>
      {/* BACKGROUND GLOBAL */}
      <div
  className="min-h-screen bg-[#efe8dd]"
  style={{
    backgroundImage: `url(${mobilebgImage})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  }}
>
  <div
    className="hidden md:block fixed inset-0"
    style={{
      backgroundImage: `url(${desktopbgImage})`,
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundAttachment: "fixed",
    }}
  ></div>

        {/* OVERLAY pentru lizibilitate */}
        <div
          className="
            relative
            min-h-screen
            bg-white/70
            md:bg-white/60
            md:backdrop-blur-sm
          "
        >
          <Header />

          <main className="pt-8">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/doctors" element={<DoctorsPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/appointment" element={<AppointmentPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/gallery" element={<GalerieFoto />} />
            </Routes>
          </main>

          <Footer />
        </div>
      </div>

      {/* CHATBOT */}
      <ChatBox />
    </Router>
  );
}

export default App;
